import React from 'react'
import { TableBody, TableContainer, Table } from '@material-ui/core'
import { Paper } from '../../common/Containers'
import RolePermissionRow from './RolePermissionRow'

const RolePermissionsMatrix = ({
  items = [],
  permissions = {},
  allowedPermissionsByKey = {},
  viewOnlyKeys = [],
  onPermissionChange,
}) => {
  return (
    // Column alignment relies on auto-layout: the empty cells rendered by
    // view-only rows line up because the full-permission rows (Contacts /
    // Organizations / Notes) in the same table populate those columns. This
    // holds as long as each category has at least one full-permission row.
    <TableContainer component={Paper} radius={9}>
      <Table style={{ minWidth: 1000 }}>
        <TableBody>
          {items.map((item) => (
            <RolePermissionRow
              key={item.key}
              itemKey={item.key}
              itemName={item.name}
              permissions={permissions[item.key] || {}}
              allowedPermissions={
                allowedPermissionsByKey[item.key] || {
                  view: true,
                  edit: true,
                  create: true,
                  delete: true,
                }
              }
              viewOnly={viewOnlyKeys.includes(item.key)}
              onChange={onPermissionChange}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default RolePermissionsMatrix
